import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { catchError, map, Observable, tap } from 'rxjs'
import { ServicePlanFeeBreakdownDto } from 'src/app/models/service-plan/service-plan-fee-breakdown-dto'
import { ServicePlanPayload } from 'src/app/models/service-plan/service-plan-payload'
import { ApplicationInsightsService } from '../application-insights/application-insights.service'
import { ConfigService } from '../config/config.service'

// Story e9-1 — calls the new side-effect-free POST api/ServicePlan/fee-summary endpoint (Task 1),
// reusing the already-built IServicePlanFeeCalculator rather than duplicating the fee schedule in
// TypeScript (Dev Notes "Fee breakdown: why a new endpoint, not a frontend recalculation").
@Injectable({
  providedIn: 'root',
})
export class ServicePlanFeeService {
  private readonly feeSummaryUrl =
    this.config.getSettings('webApi').baseUri + 'serviceplan/fee-summary'

  constructor(
    private http: HttpClient,
    private appInsights: ApplicationInsightsService,
    private config: ConfigService,
  ) {}

  GetFeeSummary(
    clientId: string,
    schemaVersion: number,
    payload: ServicePlanPayload,
  ): Observable<ServicePlanFeeBreakdownDto> {
    return this.http
      .post<ServicePlanFeeBreakdownDto>(this.feeSummaryUrl, {
        clientId,
        schemaVersion,
        payload,
      })
      .pipe(
        map((response) => response as ServicePlanFeeBreakdownDto),
        tap((_) =>
          this.appInsights.logEvent('Retrieved Service Plan fee summary'),
        ),
        catchError(async (err) => {
          throw err
        }),
      )
  }
}
